import React from "react";
import { observer } from "mobx-react-lite";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faGear,
  faJournalWhills,
  faRectangleList,
  faShield,
  faUser,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";

const LeftNav = observer(() => {
  const location = useLocation();
  const pathName = location?.pathname;

  return (
    <div className="css-foka8b">
      <Link
        to="/member"
        className={pathName === "/member" ? "css-z87e9z" : "css-6ijtmk"}
      >
        <div className="css-10j588g">
          <FontAwesomeIcon
            icon={faUser}
            className={pathName === "/member" ? "css-14thuu2" : "css-hd27fe"}
          />
          <div
            className={pathName === "/member" ? "css-iizq59" : "css-1n0484q"}
          >
            Tổng quan
          </div>
        </div>
      </Link>
      <Link
        to="/member/bank"
        className={pathName === "/member/bank" ? "css-z87e9z" : "css-6ijtmk"}
      >
        <div className="css-10j588g">
          <FontAwesomeIcon
            icon={faJournalWhills}
            className={
              pathName === "/member/bank" ? "css-14thuu2" : "css-hd27fe"
            }
          />
          <div
            className={
              pathName === "/member/bank" ? "css-iizq59" : "css-1n0484q"
            }
          >
            Quản lý địa chỉ
          </div>
        </div>
      </Link>
      <Link
        to="/member/kyc"
        className={pathName === "/member/kyc" ? "css-z87e9z" : "css-6ijtmk"}
      >
        <div className="css-10j588g">
          <FontAwesomeIcon
            icon={faShield}
            className={
              pathName === "/member/kyc" ? "css-14thuu2" : "css-hd27fe"
            }
          />
          <div
            className={
              pathName === "/member/kyc" ? "css-iizq59" : "css-1n0484q"
            }
          >
            Xác minh tài khoản
          </div>
        </div>
      </Link>
      <Link
        to="/member/change-password"
        className={
          pathName === "/member/change-password" ? "css-z87e9z" : "css-6ijtmk"
        }
      >
        <div className="css-10j588g">
          <FontAwesomeIcon
            icon={faGear}
            className={
              pathName === "/member/change-password"
                ? "css-14thuu2"
                : "css-hd27fe"
            }
          />
          <div
            className={
              pathName === "/user/respwd" ? "css-iizq59" : "css-1n0484q"
            }
          >
            Đổi mật khẩu
          </div>
        </div>
      </Link>
      <Link
        to="/member/sharing"
        className={pathName === "/member/sharing" ? "css-z87e9z" : "css-6ijtmk"}
      >
        <div className="css-10j588g">
          <FontAwesomeIcon
            icon={faUserPlus}
            className={
              pathName === "/member/sharing" ? "css-14thuu2" : "css-hd27fe"
            }
          />
          <div
            className={
              pathName === "/member/sharing" ? "css-iizq59" : "css-1n0484q"
            }
          >
            Lời mời của tôi
          </div>
        </div>
      </Link>
      <Link
        to="/member/notice"
        className={pathName === "/member/notice" ? "css-z87e9z" : "css-6ijtmk"}
      >
        <div className="css-10j588g">
          <FontAwesomeIcon
            icon={faBell}
            className={
              pathName === "/member/notice" ? "css-14thuu2" : "css-hd27fe"
            }
          />
          <div
            className={
              pathName === "/member/notice" ? "css-iizq59" : "css-1n0484q"
            }
          >
            Thông báo của tôi
          </div>
        </div>
      </Link>
      <Link
        to="/board/history"
        className={pathName === "/board/history" ? "css-z87e9z" : "css-6ijtmk"}
      >
        <div className="css-10j588g">
          <FontAwesomeIcon
            icon={faRectangleList}
            className={
              pathName === "/board/history" ? "css-14thuu2" : "css-hd27fe"
            }
          />
          <div
            className={
              pathName === "/board/history" ? "css-iizq59" : "css-1n0484q"
            }
          >
            Hóa đơn của tôi
          </div>
        </div>
      </Link>
    </div>
  );
});

export default LeftNav;
